import { render } from "./RfidItemSelector.vue?vue&type=template&id=6607c51e&scoped=true"
import script from "./RfidItemSelector.vue?vue&type=script&lang=ts"
export * from "./RfidItemSelector.vue?vue&type=script&lang=ts"

import "./RfidItemSelector.vue?vue&type=style&index=0&id=6607c51e&lang=scss&scoped=true"
import "./RfidItemSelector.vue?vue&type=style&index=1&id=6607c51e&lang=scss"
script.render = render
script.__scopeId = "data-v-6607c51e"

export default script